import { Resource } from '../resource'


export class Location extends Resource {
    lat: number | any
    lng: number | any
}